import PageMeta from "~/components/common/meta";
import { Documents } from "~/components/staff/documents";

export const DocumentsScreen = () => {
  return (
    <>
      <PageMeta title="Documents | Art Handler" />
      <Documents />
    </>
  );
};
